import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/meeting.action";
import {
  Row,
  Col,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect
} from "shards-react";
import { Upload, message, Tooltip, Spin, Modal, Button, Dropdown, Menu, Select } from 'antd';
import axios from 'axios'
import { apiUrl } from "../../config/index";
import moment from "moment";
import Moment from "react-moment";
import { httpClient } from "../../utils/HttpClient";
import { DocumentCreator } from "./attendees-doc-generator";
import { Packer } from "docx";
import FileSaver from "file-saver";
import {
  EditOutlined,
  LoadingOutlined,
  EyeOutlined,
  EllipsisOutlined,
  ExceptionOutlined,
  LockOutlined,
  CheckOutlined,
  CloseOutlined
} from '@ant-design/icons';

const filesize = require("filesize");
const { Option } = Select;

class FileItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      modalLoading: false,
      uploading: false,
      file: '',
      fileUpload: null,
      uploadedFile: '',
      versions: [],
      permission: [],
      permissionModalVisible: false,
      versionModalVisible: false
    }

    this.token = localStorage.getItem("token");

    this.uploadProps = {
      showUploadList: false,
      name: 'file',
      customRequest: () => this.handleUpload(), 
      headers: {
        Authorization: `Bearer ${this.token}`
      },
      onRemove: file => {
        this.setState({fileUpload: null})
      },
      beforeUpload: file => {
        file.uploadProgress = 0
        const fileType = file.name.split('.').pop()
        
        if(fileType === this.props.format)  {
          this.setState({uploadedFile: file})
          return true
        } else {
          message.error(`รองรับเฉพาะเอกสารประเภท .${this.props.format} เท่านั้น`);
          return false
        }
      }
    };
  }

  componentDidMount() {
    
  }  

  async handleFileNameChange(value)  {
    let file = this.state.file
    file.name = `${value}.${file.extension}`
    file.fileName = value

    await this.setState({file})
  }

  async openFileNameModal()  {
    const file = {...this.props.file}

    file.fileName = file.name.split('.')[0]
    file.extension = file.name.split('.')[1]

    this.setState({
      changeNameModalVisible: true,
      file
    })
  }

  async updateFileName()  {
    this.setState({
      changeNameModalVisible: false,
      loading: true
    })

    try {
      let response = await httpClient.patch(
        `/api/document/${this.state.file.id}`,
        this.state.file,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          },
        }
      );

      message.success('แก้ไขชื่อเอกสารเรียบร้อยแล้ว');
      this.props.onFileUpdated(response.data, this.props.type)
      this.setState({loading: false})
      
    } catch(err)  {
      this.setState({loading: false})

      if(err.response.status === 423) {
        message.error('ไม่สามารถแก้ไขชื่อเอกสารได้ เนื่องจากเอกสารถูกเปิดโดยผู้ใช้งานท่านอื่น');
      } else {
        message.error('เกิดข้อผิดพลาดในการแก้ไขชื่อเอกสาร กรุณาลองใหม่อีกครั้ง');
      }
    }
  }

  async deleteConfirmation() {
    let _this = this

    Modal.confirm({
      title: <div>ยืนยันการลบเอกสาร <span className="font-weight-bold">{this.props.file.name}</span></div>,
      content: 'เมื่อลบเอกสารแล้วจะไม่สามารถนำกลับมาได้',
      okText: 'ลบ',
      cancelText: 'ยกเลิก',
      maskClosable: true,
      onOk() {  
        _this.deleteDocument()
      }
    });
  }

  async deleteDocument()  {
    this.setState({ loading: true })

    try   {
      const response = await httpClient.delete(
        `/api/document/${this.props.file.id}/${this.props.meeting.deletedFolder}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          },
        }
      );

      message.success(<span><span className="font-weight-bold">{this.props.file.name}</span> ถูกลบเรียบร้อยแล้ว.</span>);
      this.props.onFileUpdated(null, this.props.type)
      this.setState({ loading: false })
    } catch(err)  {
      message.error('เกิดข้อผิดพลาดในการลบเอกสาร กรุณาลองใหม่อีกครั้ง');
      this.setState({ loading: false })
    } 
  }

  async getFileVersions()  {
    this.setState({
      modalLoading: true,
      versionModalVisible: true
    })

    try   {
      const response = await httpClient.get(
        `/api/document/${this.props.file.id}/versions`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          },
        }
      );

      this.setState({ versions: response.data.value })
    } catch(err)  {
      console.log(err)
    }

    this.setState({ modalLoading: false })
  }

  async versionDownload(version) {
    this.setState({
      modalLoading: true,
    })

    try   {
      const response = await httpClient.get(
        `/api/document/${this.props.file.id}/versions/${version}/content`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          },
        }
      );
    } catch(err)  {
      
    }

    this.setState({ modalLoading: false })
  }

  async getFilePermissions()  {
    this.setState({
      modalLoading: true,
      permissionModalVisible: true
    })

    try   {
      const response = await httpClient.get(
        `/api/document/${this.props.file.id}/permissions`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`
          },
        }
      );
    } catch(err)  {
      console.log(err)
    }

    this.setState({ modalLoading: false })
  }

  async handleEmailTagChange(value)  {
    
  }

  async handleUpload()  {
    this.setState({uploading : true})

    const formData = new FormData();
    formData.append('file', this.state.uploadedFile);

    try {
      const uploadResponse = await axios.request({
        method: "post", 
        url: `${apiUrl}/api/meetings/${this.props.meeting.id}/upload/file/${this.props.meeting.documentFolder}/${this.props.type}`,
        data: formData, 
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })

      //Upload final document to google storage
      if(this.props.type === '3' || this.props.type === '5') {
        const previewResponse = await await axios.request({
          method: "post", 
          url: `${apiUrl}/api/meetings/${this.props.meeting.id}/upload/file/${this.props.meeting.documentFolder}/${this.props.type}/final`,
          data: formData, 
          headers: {
            Authorization: `Bearer ${this.token}`,
          }
        })
      }

      message.success('อัพโหลดไฟล์เรียบร้อยแล้ว');
      this.props.onFileUpdated(uploadResponse.data, this.props.type)
      this.setState({ uploadedFile: null })
    } catch(err)  {
      this.setState({uploading : false})

      if(err.response.status === 409) {
        message.error('ไม่สามารถอัพโหลดเอกสารชื่อซ้ำกันได้');
      } else {
        message.error('อัพโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง');
      }
    }

    this.setState({uploading : false})
  }

  async generateAttendeeList()  {
    this.setState({loading: true})
    await this.props.getMeetingEvent(this.props.meeting.id, this.props.meeting.eventId);
    await this.props.getMeetingAttendees(this.props.meeting.id)
    
    //Set up meeting data
    const meetingDate = moment(this.props.meeting.meetingDate).locale('th').format('DD')
    const meetingMonth = moment(this.props.meeting.meetingDate).locale('th').format('MMMM')
    const meetingYear = parseInt(moment(this.props.meeting.meetingDate).locale('th').format('YYYY')) + 543
    const meetingTimeStart = moment(this.props.meeting.meetingStart).locale('th').format('HH:mm')
    const meetingTimeEnd = this.props.meeting.meetingEnd ? moment(this.props.meeting.meetingEnd).locale('th').format('HH:mm') : ''
    let roomName
    let buildingName
    let locationName

    if(this.props.roomsReducer.rooms)  {
      this.props.roomsReducer.rooms.map(item => {
        if(this.props.meeting.room == item.id)  {
          roomName = item.name
        }
      })
    }

    if(this.props.buildingsReducer.buildings)  {
      this.props.buildingsReducer.buildings.map(item => {
        if(this.props.meeting.building == item.id)  {
          buildingName = item.name
        }
      })
    }

    if(this.props.locationsReducer.locations)  {
      this.props.locationsReducer.locations.map(item => {
        if(this.props.meeting.location == item.id)  {
          locationName = item.name
        }
      })
    }
    
    const meetingDetail = {
      title: this.props.meeting.title,
      year: `ครั้งที่ ${this.props.meeting.sequence}/${meetingYear}`,
      date: `วันที่ ${meetingDate} ${meetingMonth} ${meetingYear} เวลา ${meetingTimeStart} ${meetingTimeEnd ? `- ${meetingTimeEnd} น.` : 'น.'}`,
      timeStart: meetingTimeStart,
      timeEnd: meetingTimeEnd,
      location: `ณ ${roomName} ${buildingName} ${locationName}`
    }

    const documentCreator = new DocumentCreator();

    let attendees = this.props.meetingReducer.event.attendees
    let acceptedAttendees = []
    let declinedAttendees = []

    for(const invitedAttendee of attendees)  {
      for(const attendee of this.props.meetingReducer.attendees)  {
        if(invitedAttendee.emailAddress.address === attendee.email) {
          invitedAttendee.position = attendee.positionName

          if(invitedAttendee.status.response === 'accepted')  {
            acceptedAttendees.push(invitedAttendee)
          } else if(invitedAttendee.status.response === 'declined') {
            declinedAttendees.push(invitedAttendee)
          }
        }
      }
    }

    const doc = documentCreator.create(meetingDetail, acceptedAttendees, declinedAttendees);
    const blob = await Packer.toBlob(doc)  
    const file = new File([blob], `รายงานการประชุม.docx`, {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
    
    let formData = new FormData();
    formData.append('file', file);
      
    const uploadResponse = await axios.request({
      method: "post", 
      url: `${apiUrl}/api/meetings/${this.props.meeting.id}/upload/file/${this.props.meeting.documentFolder}/${this.props.type}`,
      data: formData, 
      headers: {
        Authorization: `Bearer ${this.token}`,
      }
    })

    message.success('สร้างเอกสารเรียบร้อยแล้ว');
    this.props.onFileUpdated(uploadResponse.data, this.props.type)

    this.setState({loading: false})
  }

  render() {
    let fileName = 'ยังไม่มีเอกสาร'
    let fileIcon = this.props.format === 'docx' ? require("assets/img/word.svg") : require("assets/img/pdf.svg")
    let subtitle = this.props.format === 'docx' ? 'เอกสารสำหรับแก้ไข (.docx)' : 'เอกสารสำหรับอ่าน (.pdf)'
    let action = (
      <React.Fragment>
        { this.props.type === '4' && 
          <Button 
            type="primary" 
            htmlType="button" 
            className="mr-2" 
            disabled={ this.props.meeting.editable === 'N'}
            onClick={() => this.generateAttendeeList()}
          >สร้างรายชื่อผู้เข้าประชุม</Button>
        }
        <Upload {...this.uploadProps}>
          <Button htmlType="button" disabled={this.state.uploading || this.props.meeting.editable === 'N'}>เลือกเอกสาร</Button>
        </Upload>
      </React.Fragment>
    )

    if(this.state.uploadedFile)  {
      const uploadedFile = this.state.uploadedFile
      fileName = uploadedFile.name

      if(uploadedFile.uploadProgress === 0 && !this.state.uploading) {
        subtitle = filesize(uploadedFile.size)
      } else {
        subtitle = (
          <React.Fragment>
            <LoadingOutlined style={{ fontSize: 16, color: '#1890ff' }} spin className="mr-2" /> กำลังอัพโหลดเอกสาร
          </React.Fragment>
        )
      }
    }

    if(this.props.file)  {
      fileName = this.props.file.name

      subtitle = (
        <React.Fragment>
          { this.props.file.lastModifiedBy.user.displayName }
          <span className="dot-divider mt-1 mx-1"></span> 
          แก้ไขล่าสุดเมื่อ { <Moment format="DD/MM/YYYY HH:mm:ss" add={{ years: 543 }}>{this.props.file.lastModifiedDateTime}</Moment>}
        </React.Fragment>
      )

      action = (
        <React.Fragment>
          { this.props.format === 'docx' ?
            <React.Fragment>
              <span 
                className="mr-3"
                onClick={() => this.getFileVersions()}
              >
                <Tooltip title="ประวัติการแก้ไข">
                  <ExceptionOutlined style={{ fontSize: '24px', color: '#bbb' }} />  
                </Tooltip>
              </span>
              {/* <span 
                className="mr-3"
                onClick={() => this.getFilePermissions()}
              >
                <Tooltip title="สิทธ์การเข้าถึงเอกสาร">
                  <LockOutlined style={{ fontSize: '24px', color: '#bbb' }} />  
                </Tooltip>
              </span> */}
              { this.props.meeting.editable === 'Y' &&
                <a href={`ms-word:ofe|u|${this.props.file.webDavUrl}`} className="mr-2">
                  <Tooltip title="แก้ไข">
                    <EditOutlined style={{ fontSize: '24px', color: '#bbb' }} />  
                  </Tooltip>
                </a> 
              }
            </React.Fragment> :
            <a href={this.props.file.webUrl} className="mr-2">
              <Tooltip title="เปิดไฟล์">
                <EyeOutlined style={{ fontSize: '24px', color: '#bbb' }} />  
              </Tooltip>
            </a>  
          }
          <Dropdown 
            overlay={
              <Menu>
                <Menu.Item onClick={() => this.openFileNameModal()}>
                  แก้ไขชื่อเอกสาร
                </Menu.Item>
                <Menu.Item onClick={() => this.deleteConfirmation()}>
                  ลบ
                </Menu.Item>
              </Menu>
            } 
            placement="bottomRight" arrow>
            <EllipsisOutlined className="pointer" style={{ fontSize: 24, transform: 'rotate(90deg)' }} />
          </Dropdown>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <Spin 
          spinning={this.props.loading || this.state.loading}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          <div className="border rounded">
            <div className="py-3 px-4 d-flex align-items-center">
              <div className="d-flex align-items-center flex-fill mr-3">
                <img
                  className="mr-3"
                  width="50"
                  src={fileIcon}
                  alt="Document Icon"
                />

                <div className="flex-fill">
                  <div className="d-flex align-items-center flex-fill">
                    <div className="font-weight-bold flex-fill">{ fileName }</div>
                  </div>
                  <div className="text-muted font-12 mt-1 d-flex align-items-center">{ subtitle }</div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                { action }
              </div>
            </div>
          </div>
        </Spin>

        <Modal
          title="แก้ไขชื่อเอกสาร"
          visible={this.state.changeNameModalVisible}
          closable={false}
          okText="แก้ไข"
          cancelText="ยกเลิก"
          onOk={() => this.updateFileName()}
          onCancel={() => this.setState({changeNameModalVisible: false})}
          >
          <Row form>
            <Col md="12" className="form-group">
              <label>ชื่อเอกสาร</label>
              <InputGroup className="mb-2">
                <FormInput
                  name="fileName"
                  id="fileName"
                  onChange={(e) => this.handleFileNameChange(e.target.value)}
                  value={this.state.file.fileName}
                />
                <InputGroupAddon type="append">
                  <InputGroupText>.{this.state.file.extension}</InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Col>
          </Row>
        </Modal>

        <Modal
          title="ประวัติการแก้ไข"
          visible={this.state.versionModalVisible}
          okText="บันทึก"
          cancelText="ยกเลิก"
          footer={null}
          onCancel={() => this.setState({versionModalVisible: false})}
        >
          <Spin 
            spinning={this.state.modalLoading}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          > 
            { 
              this.state.versions.map(item => {
                return (
                  <div className="border p-3 rounded d-flex align-items-center mb-3">
                    <div className="flex-fill mr-3">
                      <div className="font-weight-bold">เวอร์ชัน {item.id}</div>
                      <div className="text-muted font-12 mt-1 d-flex align-items-center">
                        แก้ไขโดย {item.lastModifiedBy.user.displayName} 
                        <span className="dot-divider mt-1 mx-1"></span> 
                        { <Moment format="DD/MM/YYYY HH:mm:ss" add={{ years: 543 }}>{item.lastModifiedDateTime}</Moment> }  
                      </div>
                    </div>
                    {/* <Button 
                      type="primary"
                      onClick={() => this.versionDownload(item.id)}
                    >
                      ดาวน์โหลด
                    </Button> */}
                  </div>
                )
              })
            }
          </Spin>
        </Modal>

        <Modal
          title="สิทธิ์การเข้าถึงเอกสาร"
          visible={this.state.permissionModalVisible}
          okText="บันทึก"
          cancelText="ยกเลิก"
          onCancel={() => this.setState({permissionModalVisible: false})}
        >
          <Spin 
            spinning={this.state.modalLoading}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          > 
            <Row form>
              <Col md="12" className="form-group">
                <label>อีเมล</label>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="เลือกอีเมลผู้ใช้งาน"
                  onChange={this.handleEmailTagChange}
                >
                  { 
                    this.props.microsoftAccounts && this.props.microsoftAccounts.map(item => {
                      return <Option key={item.id}>{item.microsoftAccount}</Option>
                    })
                  }
                </Select>
              </Col>
            </Row>

            <Row form>
              <Col md="12" className="form-group">
                <label>สิทธิ์การเข้าถึงเอกสาร</label>
                <FormSelect
                  name="year"
                  id="year"
                  placeholder=""
                  
                >
                  <option value="">อ่าน</option>
                  <option value="">แก้ไข/ดาวน์โหลด</option>
                  <option value="">ไม่มีสิทธ์เข้าถึงเอกสาร</option>
                </FormSelect>
              </Col>
            </Row>
          </Spin>
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ 
  appReducer,
  meetingReducer,
  roomsReducer,
  buildingsReducer,
  locationsReducer
}) => ({
  appReducer,
  meetingReducer,
  roomsReducer,
  buildingsReducer,
  locationsReducer
});

const mapDispatchToProps = {
  ...actions
};

export default connect(mapStateToProps, mapDispatchToProps)(FileItem);
